class PlanRenderer {
    constructor(apiClient) {
        this.apiClient = apiClient;
        this.renderEndpoint = 'https://plan-renderer.rdrive.io/api/render';
        // TODO(CI): move to VITE_PLAN_RENDERER_API_KEY
        this.apiKey = '6sHAsRuB0WW3KL6IHURRbvNYaatfbX64DUtkTY6x8aEjVQkhf12UBiDmwufhU8Ce0kYj1SjJ7sbiG7uHhwr3PBHrgikmE63Xw4LF8adbZRLsT03S7nRZWGn6EqHN31Lj';
        this.supportedFormats = [
            'PDF',
            'PNG',
            'JPG'   
        ];
        this.viewOptions = {
            "width": 1000,
            "height": 1000,
        };
        this.quality = 50;
        this.deviceScaleFactor = 2;
    }

    async render({
        drawingId,
        drawingUrl,
        drawingTitle,
        locations = [
            {
                "id": "LOC001",
                "x": 100,
                "y": 100,
                "drawingId": drawingId,
                "title": "Ro5om 101"
            }
        ],
        issues = [
            {
                "id": "ISS001",
                "x": 400,
                "y": 577,
                "drawingId": drawingId,
                "issueTemplateCode": "MCI",
                "number": 37883,
                "createdDate": "2025-01-03T04:28:00.000Z",
                "receivedDate": "2025-01-03T09:26:00.000Z",
                "customPositioning": true,
                "icon": "safety-icon",
                "label": "testingtestingtesting",
                "issueStatusHistories": [
                    {
                        "id": "history-1",
                        "issueId": "ISS001",
                        "issueStatusId": "status-1",
                        "color": "#FF0000",
                        "title": "Open",
                        "isInitial": true,
                        "isTerminal": false,
                        "isPassed": false,
                        "createdDate": "2025-01-03T04:28:00.000Z"
                    },
                    {
                        "id": "history-2",
                        "issueId": "ISS001",
                        "issueStatusId": "status-2",
                        "color": "#FFA500",
                        "title": "In Progress",
                        "isInitial": false,
                        "isTerminal": false,
                        "isPassed": false,
                        "createdDate": "2025-01-03T08:00:00.000Z",
                        "note": "Assigned to maintenance team"
                    }
                ]
            }
        ],

        outputFormat = outputFormat
    }) {
        try {
            const normalizedFormat = outputFormat.toUpperCase();
            if (!this.supportedFormats.includes(normalizedFormat)) {
                throw new Error(`Unsupported file format. Supported formats are: ${this.supportedFormats.join(', ')}`);
            }

            const planData = {
                "drawing": {
                    "id": drawingId,
                    "url": drawingUrl,
                    "title": drawingTitle
                },
                "locations": locations,
                "issues": issues,
                "drilldowns": [],
                "processes": [],
                "tasks": [
                    {
                        "id": "TASK001",
                        "code": "1.1",
                        "wbs": [
                            "1",
                            "1"
                        ],
                        "title": "Install Drywall - Room 101",
                        "viewableLocationIds": [
                            "LOC001"
                        ],
                        "timeRanges": [
                            {
                                "progress": "50",
                                "duration": "P5D",
                                "isDefault": true
                            }
                        ]
                    }
                ]
            };

            const requestBody = {
                planData,
                viewOptions: this.viewOptions,
                outputFormat: normalizedFormat,
                quality: this.quality,
                deviceScaleFactor: this.deviceScaleFactor
            };

            // POST request to get the binary response directly
            const response = await fetch(this.renderEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-Key': this.apiKey
                },
                body: JSON.stringify(requestBody)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // Get the Content-Type from the response headers
            const contentType = response.headers.get('Content-Type') || 'application/pdf'; // Default to PDF if not specified

            // Determine file extension based on Content-Type
            let fileExtension = '.pdf';
            if (contentType.includes('image/png')) {
                fileExtension = '.png';
            } else if (contentType.includes('application/pdf')) {
                fileExtension = '.pdf';
            } else if (contentType.includes('image/jpeg')) {
                fileExtension = '.jpg';
            } else {
                console.warn('Unknown Content-Type:', contentType);
                // Fallback to requested format
                fileExtension = `.${normalizedFormat.toLowerCase()}`;
            }

            // Get the binary data as a Blob, overriding type if necessary
            const blob = await response.blob();
            const typedBlob = new Blob([blob], { type: contentType });

            // Create a temporary URL for the blob
            const url = window.URL.createObjectURL(typedBlob);

            // Create a temporary link element to trigger download
            const link = document.createElement('a');
            link.href = url;
            link.download = `rendered-plan${fileExtension}`; // Set filename with dynamic extension
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error rendering plan:', error);
            throw new Error('Failed to render plan: ' + error.message);
        }
    }
}

export default PlanRenderer;